var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrowWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.772,
    height: 25.226,
    viewBox: "0 0 23.772 25.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 190",
    d: "m13124.193 1059 11.533 11.533 11.532-11.533",
    transform: "translate(-13123.84 -1046.014)",
    style: {
      fill: "none",
      stroke: "#e9e7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 140",
    transform: "translate(11.887)",
    style: {
      fill: "none",
      stroke: "#e9e7e1"
    },
    d: "M0 24.519V0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowWhiteIcon);
export default __webpack_public_path__ + "static/media/down-arrow-white-icon.a800de9c3daac6fdb13b107e9a21513c.svg";
export { ForwardRef as ReactComponent };